import React from "react";
import style from "css/workspace.module.css";
import { Link, useLocation } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { useMediaQuery } from "react-responsive";

function Detailcommon(props) {
  const { pathname } = useLocation();
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });

  return (
    <div
      style={
        pathname === "/smart-space/work/conference"
          ? {
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }
          : {
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              borderTop: "1px solid #c0c0c0",
            }
      }
    >
      <div className={style.commonBody}>
        {props.bodyHeader}

        <div className={style.bodyInfoWrap}>
          {props.bodyInfo.map((info, idx) =>
            isMobile ||
            isTablet ||
            (!isMobile && !isTablet && info.id % 2 === 1) ? (
              <div className={style.bodyInfo} key={idx}>
                <div className={style.bodyInfoImg}>
                  <img
                    alt=""
                    src={
                      !isMobile && !isTablet
                        ? `${process.env.REACT_APP_CLIENT_URL + info.img}`
                        : `${process.env.REACT_APP_CLIENT_URL + info.img_m}`
                    }
                  />
                </div>
                <div className={style.bodyInfoTxt}>
                  <div className={style.bodyInfoTxtBody}>
                    <p>{info.id}</p>
                    <p>{info.title}</p>
                    {info.txt}
                  </div>
                </div>
              </div>
            ) : (
              <div className={style.bodyInfo} key={idx}>
                <div className={style.bodyInfoTxt}>
                  <div className={style.bodyInfoTxtBody}>
                    <p>{info.id}</p>
                    <p>{info.title}</p>
                    {info.txt}
                  </div>
                </div>
                <div className={style.bodyInfoImg}>
                  <img
                    alt=""
                    src={`${process.env.REACT_APP_CLIENT_URL}` + info.img}
                  />
                </div>
              </div>
            )
          )}

          <div className={style.bodyLine} />

          <div className={style.bodyFooter}>
            {props.bodyFooterTitle}
            <div className={style.bodyFooterCardWrap}>
              {props.bodyFooter.map((info, idx) => (
                <div key={idx} className={style.bodyFooterCard}>
                  <p>{info.id}</p>
                  <p>{info.title}</p>
                  <p>{info.txt}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className={style.commonCompose}>
        <div className={style.commonCompseBody}>
          {props.composeHeader}

          <Swiper
            scrollbar={{ draggable: true }}
            slidesPerView={"auto"}
            spaceBetween={50}
            modules={[Scrollbar]}
            className={style.commonComposeCardWrap}
            observer={true}
            observeParents={true}
            observeSlideChildren={true}
            grabCursor={true}
          >
            {props.compose.map((info, index) => (
              <SwiperSlide className={style.commonComposeCard} key={index}>
                <div className={style.commonComposeCardImg}>
                  <p>
                    <font>{info.id}</font> / {props.compose.length}
                  </p>
                  <img
                    alt=""
                    src={`${process.env.REACT_APP_CLIENT_URL}` + info.img}
                  />
                </div>
                <div className={style.commonComposeCardTxt}>
                  <p>{info.title}</p>
                  <p>{info.txt}</p>
                </div>
                <div className={style.commonComposeCardMore}>
                  {/* <Link to={`${process.env.REACT_APP_CLIENT_URL + info.link}`}> */}
                  <div onClick={info.onClick}>
                    <font>More</font>{" "}
                    <img
                      alt=""
                      src={
                        `${process.env.REACT_APP_CLIENT_URL}` +
                        "img/smartspace/arrowRight.png"
                      }
                    />
                  </div>
                  {/* </Link> */}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className={style.commonComposeFooter}>
            <div
              style={{
                backgroundImage:
                  "url('" +
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/smartspace/composefooterImg.png')",
              }}
            >
              <p>
                <img
                  alt=""
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/bang.png"
                  }
                />
              </p>
              <p>
                <font>기업 환경에 맞춰</font> 선택하여 구축 가능합니다. 상담을
                통해 정확히 진단해 보세요.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Detailcommon;
